import React, { useState } from "react";

import PastJobs from "./Pastjobs";
const PastJobsMainComponent = ({}) => {
  return (
    <div className="pt-[83px] max-w-[1440px] m-auto md:px-6 px-4">
    {" "}
    <PastJobs />
  </div>
  );
};

export default PastJobsMainComponent;   